import React from 'react';
import { observer } from 'mobx-react';
import { InputLabel } from '@this/shared/ui/inputs/form_control';
import SimpleLoading from '@this/shared/simple_loading/simple_loading';
import type FreeeAccountItem from '@this/domain/organization/freee_account_item';
import type ExpensesAccountType from '@this/domain/expenses/expenses_account_type';
import { AutocompleteSelect } from '@this/shared/ui/inputs/autocomplete/autocomplete';
import { Button } from '../../shared/ui/inputs/button';
import { Input } from '../../shared/ui/inputs/input';
import { Textarea } from '../../shared/ui/inputs/textarea';

type Props = {
  type: ExpensesAccountType;
  submitting: boolean;
  isFreeeConnected: boolean;
  freeeAccountItems: FreeeAccountItem[];
  onSubmit: () => void;
  onClickCancel: () => void;
};

const Form: React.FC<Props> = ({
  type,
  submitting,
  isFreeeConnected,
  freeeAccountItems,
  onSubmit,
  onClickCancel
}) => {
  const selectedFreeeAccountItem = freeeAccountItems.find(item => item.id.toString() === type.freeeAccountItemId);

  return (
    <>
      <form onSubmit={() => onSubmit()}>
        <div>
          <div style={{ marginBottom: 16 }}>
            <InputLabel htmlFor="name" className="type-edit__label">
              勘定科目名
            </InputLabel>
            <Input
              id="name"
              type="text"
              value={type.name || ''}
              onChange={e => {
                type.name = e.target.value;
              }}
              fullWidth
            />
          </div>
          <div style={{ marginBottom: 16 }}>
            <InputLabel htmlFor="code" className="type-edit__label">
              勘定科目コード
            </InputLabel>
            <Input
              id="code"
              type="text"
              value={type.code || ''}
              onChange={e => {
                type.code = e.target.value;
              }}
              fullWidth
            />
          </div>
          {isFreeeConnected && (
            <div style={{ marginBottom: 16 }}>
              <InputLabel className="type-edit__label">freee勘定科目名</InputLabel>
              <AutocompleteSelect
                options={freeeAccountItems}
                value={selectedFreeeAccountItem || null}
                getOptionLabel={item => item.name}
                onChange={(_e, item) => {
                  type.freeeAccountItemId = item?.id.toString();
                }}
                placeholder="勘定科目を検索"
                fullWidth
              />
            </div>
          )}
          <div style={{ marginBottom: 16 }}>
            <InputLabel htmlFor="departments" className="type-edit__label">
              部署コード
            </InputLabel>
            <Textarea
              id="departments"
              placeholder={'部署コード1\n部署コード2'}
              value={type.departments || ''}
              onChange={e => {
                type.departments = e.target.value;
              }}
              style={{ maxWidth: 500 }}
              rowsMin={4}
            />
            <p>
              出張申請時にこの勘定科目を選択できるようにしたい費用負担部署の部署コードを改行区切りで入力ください。
              <br />
              指定しない場合、すべてのユーザがこの勘定科目を選択できます。
              <br />
              <br />
              出張申請時にユーザが勘定科目を選択できるようにするためには、別途「原価計算オプション」をお申し込みいただく必要があります。
            </p>
          </div>
        </div>
        <div style={{ marginTop: '20px' }}>
          <Button style={{ marginRight: '10px' }} disabled={submitting} onClick={() => onClickCancel()}>
            キャンセル
          </Button>
          <Button disabled={submitting} onClick={() => onSubmit()}>
            保存
          </Button>
        </div>
      </form>
      {submitting && <SimpleLoading />}
    </>
  );
};

export default observer(Form);
